<template>
  <div>
    <condensed-issue v-for="paper in papersList" :key="paper.id" v-bind:issue="paper"></condensed-issue>
  </div>
</template>

<script>
  import CondensedIssue from '@/components/shared/CondensedIssueComponent'
  export default {
    name: 'hundered-plus-papers',
    components: {
      CondensedIssue
    },
    data () {
      return {
        papersList: []
      }
    },
    props: {
      collectionId: {
        default: function () {
          return this.$route.params ? this.$route.params.id : undefined
        }
      }
    },
    created () {
      // ToDO: call collection's articles request item with collectionId param
      this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
        this.papersList = response.body.articles
      }, function () {
      })
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// HundredPlusPapersPage.vue?dae9f9a2